export const CourseTypeConstants = {
    DEDICATED_HUNTER_AND_SPORTS_PERSON: 'e5a10847-cb0e-4159-b3c6-6738069a743b',
    DEDICATED_HUNTER: 'c777177f-fb99-4107-a7d2-7352b9b1c89e',
    DEDICATED_SPORTS_PERSON: 'cbdff36b-d3a8-48d4-ba9a-bf07d6993b9c'
}